import React from "react";

import Home from "./screens/home/Home";

// import ServicesBuilding from "./screens/servicesBuilding/ServicesBuilding";
import Contact from "./screens/contact/Contact";
import Services from "./screens/services/Services";
import AboutUs from "./screens/aboutUs/AboutUs";
import SwadaaEmpowerment from "./screens/swadaaEmpowerment/SwadaaEmpowerment";
import SwadaaExpress from "./screens/swadaaExpress/SwadaaExpress";
import SwadaaSecurity from "./screens/swadaaSecurity/SwadaaSecurity";
import Projects from "./screens/projects/Projects";

export const Homepage = () => {
  return <Home />;
};

export const ContactPage = () => {
  return <Contact />;
};

export const ServicesPage = () => {
  return <Services />;
};

export const AboutUsPage = () => {
  return <AboutUs />;
};

export const SwadaaEmpowermentPage = () => {
  return <SwadaaEmpowerment />;
};
export const SwadaaExpressPage = () => {
  return <SwadaaExpress />;
};
export const SwadaaSecurityPage = () => {
  return <SwadaaSecurity />;
};

export const ProjectsPage = () => {
  return <Projects />;
};
